module.exports = __webpack_public_path__ + "img/upload-interior-exotics.5640db9b.jpg";